<template>
  <v-card id="edit-buy-get-free-promotion">
    <flewid-dialog
      draggable
      scrollable
      persistent
      content-class="i-dialog"
      v-model="unsavedTiersDialog"
      width="500"
    >
      <v-card>
        <template>
          <v-card-title class="i-dialog-header-div">
            <span class="g-heading-m g-bold">Warning</span>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-actions class="i-dialog-actions-div pt-6 justify-end">
            <v-btn
              rounded
              text
              class="i-btn-text-black"
              @click="unsavedTiersDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              rounded
              class="i-btn-block-secondary mr-4"
              @click="confirmSaveBuyGetFreePromotion"
              >Confirm</v-btn
            >
          </v-card-actions>
        </template>
      </v-card>
    </flewid-dialog>

    <v-card-title class="i-card-title-div">
      <v-row class="align-center">
        <v-col cols="12" sm="9">
          <span class="g-bold g-heading-l">{{
            newPromotion ? 'New Buy Get Free' : 'Edit Buy Get Free'
          }}</span>
        </v-col>
        <v-col cols="12" sm="3">
          <i-instructions
            instructionKey="data-maintenance/buy-get-free/add-dialog"
          ></i-instructions>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text class="py-8 i-card-content-div">
      <v-form @submit.prevent>
        <p class="g-bold g-heading-s g-text-color-black">Buy Get Free Type</p>
        <v-radio-group
          class="i-radio-group"
          :disabled="!newPromotion"
          @change="resetPromotionForm"
          v-model="promotionType"
        >
          <v-row>
            <v-col cols="12" md="4" class="pb-0">
              <div
                class="item-div-mini mb-0"
                :class="{ 'item-div-active': promotionType === FAMILY_GROUP }"
              >
                <v-radio
                  label="By Family Group"
                  :value="FAMILY_GROUP"
                ></v-radio>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="pb-0">
              <div
                class="item-div-mini mb-0"
                :class="{ 'item-div-active': promotionType === SINGLE_PRODUCT }"
              >
                <v-radio
                  label="By Product (Live products only)"
                  :value="SINGLE_PRODUCT"
                  class="pl-2 flex-fill"
                ></v-radio>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="pb-0">
              <div
                class="item-div-mini mb-0"
                :class="{ 'item-div-active': promotionType === BY_RANGE }"
              >
                <v-radio
                  label="By Range"
                  :value="BY_RANGE"
                  class="pl-2 flex-fill"
                ></v-radio>
              </div>
            </v-col>
          </v-row>
        </v-radio-group>

        <template v-if="familyPromotion">
          <p class="g-bold g-heading-s g-text-color-black mt-3 mt-md-5">
            Family Group
          </p>

          <v-autocomplete
            attach
            background-color="#0000000f"
            class="mt-4"
            clearable
            dense
            :disabled="!newPromotion"
            :items="listFamilyGroups"
            item-disabled="disabled"
            label="Select Family Group *"
            outlined
            v-model="selectedFamilyGroup"
            :rules="[(v) => !!v || 'Family Group selection required']"
            small-chips
            @change="handleFamilyGroupSelection"
            item-text="text"
            item-value="value"
          >
            <template v-slot:item="{ item, attrs, on }">
              <v-list-item v-bind="attrs" v-on="on">
                <v-list-item-content>
                  <v-list-item-title :class="{ 'text-grey': item.disabled }">
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <template v-slot:selection="{ item }">
              <v-tooltip
                bottom
                content-class="family-tooltip"
                transition="fade-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-chip v-bind="attrs" v-on="on" small class="ma-1" outlined>
                    {{ item.text }}
                  </v-chip>
                </template>

                <div class="tooltip-content">
                  <strong>Products in this Family Group:</strong>
                  <ul>
                    <li
                      v-for="(productName, idx) in getFamilyGroupProductsById(
                        item.value
                      )"
                      :key="idx"
                    >
                      {{ productName }}
                    </li>
                  </ul>
                </div>
              </v-tooltip>
            </template>
          </v-autocomplete>
        </template>

        <template v-if="productPromotion">
          <p class="g-bold g-heading-s g-text-color-black mt-3 mt-md-5">
            Product
          </p>
          <v-autocomplete
            attach
            background-color="#0000000f"
            class="mt-4"
            clearable
            dense
            :disabled="!newPromotion"
            :items="visibleByProductList"
            item-title="text"
            item-disabled="disabled"
            label="Select Product *"
            outlined
            :rules="[(v) => !!v || 'Product selection required']"
            item-text="text"
            item-value="value"
            v-model:search-input="productSearchInput"
            small-chips
            v-model="selectedProduct"
            @change="handleProductSelection"
          >
            <template v-slot:selection>
              {{ selectedProduct.supplierItemId }} /
              {{ selectedProduct.tradeItemDescription }}
            </template>
            <template v-slot:item="{ item, attrs, on }">
              <v-list-item v-bind="attrs" v-on="on">
                <v-list-item-content>
                  <v-list-item-title :class="{ 'text-grey': item.disabled }">
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>
        </template>

        <template v-if="rangePromotion">
          <p class="g-bold g-heading-s g-text-color-black mt-3 mt-md-5">
            Select Products for Buy Range
          </p>
          <v-autocomplete
            attach
            background-color="#0000000f"
            class="mt-4"
            clearable
            dense
            :disabled="!newPromotion"
            :items="visibleRangeProducts"
            item-disabled="disabled"
            label="Select Multiple Products *"
            outlined
            multiple
            small-chips
            v-model="selectedRangeProducts"
            item-text="text"
            item-value="value"
            return-object
            v-model:search-input="rangeProductSearchInput"
            @change="handleRangeProductSelection"
          >
            <template v-slot:selection="{ index }">
              {{ selectedRangeProducts[index].text }}
            </template>
            <template v-slot:item="{ item, attrs, on }">
              <v-list-item v-bind="attrs" v-on="on" #default="{ active }">
                <v-list-item-action>
                  <v-checkbox
                    :input-value="active"
                    :model-value="active"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title
                    :class="{ 'text-disabled': item.disabled }"
                  >
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>
          <v-alert
            v-if="hasMixedRangeProductTypes"
            border="left"
            dense
            text
            outlined
            type="error"
            elevation="1"
            class="mt-3 i-alert"
          >
            <span>
              Buy Get Free range cannot mix Service with Grocery/Liquor
              products.
            </span>
          </v-alert>
        </template>
        <template v-if="supportsRetailerChoice">
          <p class="g-bold g-heading-s g-text-color-black mt-3 mt-md-5">
            Free Product Selection
          </p>
          <legacy-radio-group
            :disabled="!newPromotion"
            name="edit-buy-get-free-free-selection"
            :default-col-props="{ cols: '12', class: 'pb-0' }"
            :options="[
              { label: 'Fixed free product', value: FIXED_PRODUCT },
              {
                label: 'Retailer chooses one SKU from eligible products',
                value: RETAILER_CHOICE
              }
            ]"
            v-model="freeSelectionMode"
          />
        </template>
        <v-row>
          <v-col cols="12" md="6">
            <p class="g-bold g-heading-s g-text-color-black mt-2 mt-md-4 mb-3">
              Buy Get Free Name
              <v-icon
                class="i-tooltip-color pb-1"
                small
                v-tooltip="'Change name if required'"
              >
                mdi-help-circle-outline
              </v-icon>
            </p>
            <v-alert
              border="left"
              dense
              text
              outlined
              type="info"
              elevation="1"
              class="i-alert"
              v-if="!activePromotion"
            >
              <ul>
                <li>Name needs to be representative of the Buy Get Free</li>
                <li>
                  It will be displayed in the
                  {{ isILR ? 'Customer(s)' : 'Retailer(s)' }} Marketplace
                </li>
              </ul>
            </v-alert>

            <v-text-field
              outlined
              background-color="#0000000f"
              dense
              v-model="promotionName"
              label="Buy Get Free Name *"
              :disabled="
                activePromotion ||
                !(
                  selectedProduct ||
                  selectedFamilyGroup ||
                  selectedRangeProducts.length
                ) ||
                !newPromotion
              "
              :rules="[
                (v) => !!v || 'Buy get Free Name is required',
                (v) =>
                  (!!v && v.length <= 60) ||
                  'Buy Get Free Name cannot exceed 60 characters'
              ]"
            >
            </v-text-field>
          </v-col>
          <v-col cols="6" v-if="$vuetifyDisplay.mdAndUp && rangePromotion">
            <div>
              <p class="g-bold g-heading-s g-text-color-black mt-2 mt-md-4">
                Upload Promotion Image
              </p>
            </div>
            <div class="image-upload-container">
              <v-card
                class="image-preview-card d-flex align-center justify-center"
              >
                <v-img
                  v-if="imagePreviewUrl"
                  :src="imagePreviewUrl"
                  class="image-fit"
                  contain
                  max-height="100%"
                  max-width="100%"
                ></v-img>
                <div class="image-overlay" v-if="!imagePreviewUrl">
                  <label
                    class="image-label text-center"
                    for="promotion-image-input"
                  >
                    <p>
                      <v-icon class="upload-icon"
                        >mdi-cloud-upload-outline</v-icon
                      >
                    </p>
                    <p class="g-bold g-heading-s">
                      Click here to upload an image
                    </p>
                  </label>
                </div>
                <div v-if="rangePromotion" class="image-controls">
                  <v-btn icon class="edit-btn" @click="triggerImageUpload">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon class="remove-btn" @click="removeImage">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </v-card>
              <input
                accept="image/jpeg, image/png, image/webp, image/avif, .jpg, .jpeg, .png, .webp, .avif"
                id="promotion-image-input"
                ref="imageUploader"
                type="file"
                style="display: none"
                @change="handleImageUpload"
              />
            </div>
          </v-col>
          <v-col cols="12" v-if="$vuetifyDisplay.smAndDown && rangePromotion">
            <div>
              <p class="g-bold g-heading-s g-text-color-black mt-2 mt-md-4">
                Upload Promotion Image
              </p>
            </div>
            <div class="image-upload-container">
              <v-card
                class="image-preview-card d-flex align-center justify-center"
              >
                <v-img
                  v-if="imagePreviewUrl"
                  :src="imagePreviewUrl"
                  class="image-fit"
                  contain
                  max-height="100%"
                  max-width="100%"
                ></v-img>
                <div class="image-overlay" v-if="!imagePreviewUrl">
                  <label
                    class="image-label text-center"
                    for="promotion-image-input"
                  >
                    <p>
                      <v-icon class="upload-icon"
                        >mdi-cloud-upload-outline</v-icon
                      >
                    </p>
                    <p class="g-bold g-heading-s">
                      Click here to upload an image
                    </p>
                  </label>
                </div>
                <div class="image-controls">
                  <v-btn icon class="edit-btn" @click="triggerImageUpload">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon class="remove-btn" @click="removeImage">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </v-card>
              <input
                accept="image/jpeg, image/png, image/webp, image/avif, .jpg, .jpeg, .png, .webp, .avif"
                id="promotion-image-input"
                ref="imageUploader"
                type="file"
                style="display: none"
                @change="handleImageUpload"
              />
            </div>
          </v-col>
        </v-row>

        <p class="g-bold g-heading-s g-text-color-black mt-2 mt-md-4">
          Buy Get Free Date Range
          <v-icon
            class="i-tooltip-color pb-1"
            small
            v-tooltip="
              'Starts at 12:00am & Ends at 11:59pm on the submitted dates'
            "
          >
            mdi-help-circle-outline
          </v-icon>
        </p>
        <v-row align="center">
          <v-col cols="12" sm="6">
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              :nudge-right="15"
              :nudge-top="30"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  append-icon="mdi-calendar"
                  background-color="#0000000f"
                  class="mt-0"
                  dense
                  label="Start Date *"
                  outlined
                  readonly
                  v-on="on"
                  v-model="startDateDisplay"
                  :disabled="
                    activePromotion ||
                    !(
                      selectedProduct ||
                      selectedFamilyGroup ||
                      selectedRangeProducts.length
                    )
                  "
                  :rules="[
                    (v) => !!v || 'Start Date required',
                    validStartSate(startDate, endDate)
                  ]"
                ></v-text-field>
              </template>
              <v-date-picker
                :min="minAllowedStartDate"
                v-model="startDate"
                @change="startDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6">
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              :nudge-right="15"
              :nudge-top="30"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  append-icon="mdi-calendar"
                  background-color="#0000000f"
                  dense
                  :disabled="
                    !(
                      selectedProduct ||
                      selectedFamilyGroup ||
                      selectedRangeProducts.length
                    )
                  "
                  label="End Date *"
                  outlined
                  readonly
                  :rules="[
                    (v) => !!v || 'End Date required',
                    validEndDate(startDate, endDate)
                  ]"
                  v-on="on"
                  v-model="endDateDisplay"
                ></v-text-field>
              </template>
              <v-date-picker
                :min="minAllowedEndDate"
                v-model="endDate"
                @change="endDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-col cols="12" md="6">
          <p class="g-bold g-heading-s g-text-color-black mt-2 mt-md-4 mb-3">
            Max Free Units Cap
            <v-icon
              class="i-tooltip-color pb-1"
              small
              v-tooltip="
                'Maximum free units per product. Entering a value enables only a single-tier promotion. And just leave empty for up to three-tiers.'
              "
            >
              mdi-help-circle-outline
            </v-icon>
          </p>
          <v-text-field
            outlined
            background-color="#0000000f"
            dense
            v-model.number="maxFreeUnitsCap"
            type="number"
            label="Max Cap (Free Units)"
            :disabled="multiTierActive"
            :rules="[
              (v) =>
                v === null ||
                v === undefined ||
                v === '' ||
                v > 0 ||
                'Must be greater than 0'
            ]"
          />
        </v-col>

        <p class="g-bold g-heading-s g-text-color-black mt-2">Target Type</p>
        <legacy-radio-group
          :disabled="!newPromotion"
          item-class="item-div-mini"
          name="edit-buy-get-free-target-type"
          :default-col-props="{ cols: '12', md: '4', class: 'pb-0' }"
          :options="[
            { label: 'National', value: NATIONAL },
            { label: 'State(s)', value: STATE },
            { label: 'Banner Group(s)', value: BANNER_GROUP },
            {
              label: 'Multi-Store Operator(s)',
              value: MULTI_STORE_OPERATOR
            },
            {
              label: isILR ? 'Customer(s)' : 'Retailer(s)',
              value: RETAILER_STORE
            }
          ]"
          v-model="targetType"
          @change="handleTargetTypeChange"
        />

        <template v-if="targetType === BANNER_GROUP">
          <p class="g-bold g-heading-s g-text-color-black mt-3 mt-md-5">
            Banner Group
          </p>
          <v-autocomplete
            attach
            background-color="#0000000f"
            class="mt-4 mb-6"
            clearable
            deletable-chips
            dense
            :disabled="!newPromotion"
            :items="targetBannerGroups"
            label="Select Banner Group(s)"
            multiple
            outlined
            :rules="[(v) => !!v.length || '']"
            v-model:search-input="searchInput"
            small-chips
            v-model="targetBannerGroupIds"
            @change="searchInput = ''"
          ></v-autocomplete>
        </template>
        <template v-if="targetType === MULTI_STORE_OPERATOR">
          <p class="g-bold g-heading-s g-text-color-black mt-3 mt-md-5">
            Multi-Store Operator
          </p>
          <v-autocomplete
            attach
            background-color="#0000000f"
            class="mt-3 mb-6"
            clearable
            deletable-chips
            dense
            :disabled="!newPromotion"
            :items="targetMultiStoreOperators"
            label="Select Multi-Store Operator(s)"
            multiple
            outlined
            :rules="[(v) => !!v.length || '']"
            v-model:search-input="searchInput"
            small-chips
            v-model="targetMultiStoreOperatorIds"
            @change="searchInput = ''"
          ></v-autocomplete>
        </template>
        <template v-if="targetType === RETAILER_STORE">
          <p class="g-bold g-heading-s g-text-color-black mt-3 mt-md-5">
            {{ isILR ? 'Customer(s)' : 'Retailer(s)' }}
          </p>
          <v-autocomplete
            attach
            background-color="#0000000f"
            class="mt-3 mb-9"
            clearable
            deletable-chips
            dense
            :disabled="!newPromotion"
            hide-details
            :items="targetStores"
            :label="`Select ${isILR ? 'Customer(s)' : 'Retailer(s)'}`"
            multiple
            outlined
            :rules="[(v) => !!v.length || '']"
            v-model:search-input="searchInput"
            :item-disabled="savedListApplied ? () => true : () => false"
            small-chips
            v-model="targetStoreIds"
            @change="searchInput = ''"
            @click:clear="resetRetailers"
          ></v-autocomplete>
          <retailer-list-action-button
            class="mb-2"
            :supplier-id="selectedSupplierId"
            :selected-retailers="targetStoreIds"
            :disabled="!newPromotion"
            :saved-list-applied="savedListApplied"
            mode="useOnly"
            @apply="handleApplySavedRetailers"
          />
        </template>
        <v-alert
          v-if="!validPromotionSelection"
          border="left"
          dense
          text
          outlined
          type="info"
          elevation="1"
          class="mt-4 i-alert"
        >
          <span>Select a Family Group or a single Product first</span>
        </v-alert>
        <v-alert
          v-if="hasUnsavedTierDraft"
          border="left"
          dense
          outlined
          text
          type="warning"
          elevation="1"
          class="mb-2 i-alert"
        >
          <span
            >Warning – This Promotion has Buy Get Tiers that have not been added
            yet</span
          >
        </v-alert>

        <buy-get-free-tiers-table
          v-if="targetType"
          :target-type="targetType"
          :selected-product="selectedProduct"
          :selected-family-group-products="filteredFamilyGroupProducts"
          :selected-range-products="selectedRangeProductObjects"
          :free-product-candidates="freeProductCandidates"
          :available-states="availableStates"
          :initial-national-tiers="nationalTiers"
          :initial-state-tiers="stateTiers"
          :new-promotion="newPromotion"
          :buyProducts="selectedRangeProductObjects"
          :max-free-units-cap="
            maxFreeUnitsCap === '' ? null : Number(maxFreeUnitsCap)
          "
          :cap-single-tier="Boolean(maxFreeUnitsCap)"
          :requires-fixed-free-product="requiresFixedFreeProduct"
          @update-national-tiers="updateNationalTiers"
          @update-state-tiers="updateStateTiers"
        />
      </v-form>
    </v-card-text>

    <v-card-actions class="i-dialog-actions-div pt-6 justify-end">
      <v-btn rounded text class="i-btn-text-black" @click="$emit('cancel')"
        >Cancel</v-btn
      >
      <v-btn
        rounded
        class="i-btn-block-secondary mr-4"
        :loading="saving"
        :disabled="!validPromotion"
        @click="handleSaveBuyGetFreePromotion"
        >{{ newPromotion ? 'Create' : 'Update' }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex'
import {
  addBuyGetFreePromotion,
  updateBuyGetFreePromotion
} from '@/services/buyGetPromotion'
import FieldValidators from '@/utils/FieldValidators'
import FlewidDialog from '@/components/FlewidDialog'
import LegacyRadioGroup from '@/components/LegacyRadioGroup.vue'
import BuyGetFreeTiersTable from './BuyGetFreeTiersTable'
import { BuyGetFreeHelper } from '@/modules/dataMaintenance/helper/BuyGetFreeHelper'
import {
  minAllowedPromotionEndDate,
  minAllowedPromotionStartDate
} from '@/modules/dataMaintenance/helper/PromotionPublishSchedule'
import iInstructions from '@/components/Instructions'
import RetailerListActionButton from '@/components/RetailerListActionButton.vue'
import { buildVisibleProductOptions } from '@/modules/dataMaintenance/helper/ProductAutocompleteHelper'

const PROMOTION_FIELDS = {
  selectedFamilyGroup: null,
  selectedProduct: null,
  selectedRangeProducts: [],
  endDate: null,
  startDate: null,
  promotionName: null,
  targetType: null
}

const PROMOTION_TYPE = {
  FAMILY_GROUP: 'FAMILY_GROUP',
  SINGLE_PRODUCT: 'SINGLE_PRODUCT',
  BY_RANGE: 'BY_RANGE'
}

const TARGET_TYPE = {
  NATIONAL: 'NATIONAL',
  STATE: 'STATE',
  BANNER_GROUP: 'BANNER_GROUP',
  MULTI_STORE_OPERATOR: 'MULTI_STORE_OPERATOR',
  RETAILER_STORE: 'RETAILER_STORE'
}

const FREE_SELECTION_MODE = {
  FIXED_PRODUCT: 'FIXED_PRODUCT',
  RETAILER_CHOICE: 'RETAILER_CHOICE'
}

export default {
  components: {
    LegacyRadioGroup,
    FlewidDialog,
    BuyGetFreeTiersTable,
    iInstructions,
    RetailerListActionButton
  },

  data: () => ({
    unsavedTiersDialog: false,
    endDateMenu: false,
    startDateMenu: false,
    searchInput: '',
    productSearchInput: '',
    rangeProductSearchInput: '',
    promotionType: null,
    originalBuyGetPromotion: {},
    saving: false,
    selectedRangeProducts: [],
    targetType: null,
    imageFile: null,
    savedListApplied: false,
    targetBannerGroupIds: [],
    targetMultiStoreOperatorIds: [],
    targetStoreIds: [],
    freeSelectionMode: FREE_SELECTION_MODE.FIXED_PRODUCT,
    maxFreeUnitsCap: null,
    nationalTiers: [{ buyQuantity: '', freeProduct: '', freeQuantity: '' }],
    stateTiers: [
      {
        name: 'ACT',
        tiers: [{ buyQuantity: '', freeProduct: '', freeQuantity: '' }]
      },
      {
        name: 'NSW',
        tiers: [{ buyQuantity: '', freeProduct: '', freeQuantity: '' }]
      },
      {
        name: 'QLD',
        tiers: [{ buyQuantity: '', freeProduct: '', freeQuantity: '' }]
      }
    ],
    ...FieldValidators,
    ...PROMOTION_FIELDS,
    ...PROMOTION_TYPE,
    ...TARGET_TYPE,
    ...FREE_SELECTION_MODE
  }),

  props: {
    familyGroups: Array,
    products: Array,
    buyGetFreePromotion: Object,
    allBuyGetPromotions: Array
  },

  mounted() {
    if (this.newPromotion) {
      this.targetType = this.NATIONAL
    } else {
      this.copyBuyGetPromotion()
    }
    this.originalBuyGetPromotion = _.cloneDeep(this.createBluePrint())
  },

  computed: {
    ...mapState('preferences', ['selectedSupplierId']),
    ...mapState('bannerGroups', ['bannerGroups']),
    ...mapState('multiStoreOperators', ['multiStoreOperators']),
    ...mapState('stores', ['retailerStores']),
    ...mapState('pricingRegions', ['pricingRegions']),
    ...mapGetters('tenant', ['isILR', 'tenantCountryRegion']),

    imagePreviewUrl() {
      return this.imageFile
        ? URL.createObjectURL(this.imageFile)
        : this.buyGetFreePromotion?.promotionImageUrl || ''
    },

    filteredFamilyGroupProducts() {
      if (this.selectedFamilyGroup) {
        const familyGroup = this.familyGroups.find(
          (group) => group.id === this.selectedFamilyGroup
        )
        return this.products.filter((product) =>
          familyGroup.productCodes.includes(product.productCode)
        )
      }
      return []
    },

    activePromotion() {
      return this.buyGetFreePromotion?.status === 'ACTIVE'
    },

    changesMade() {
      return !_.isEqual(this.originalBuyGetPromotion, this.createBluePrint())
    },

    familyPromotion() {
      return this.promotionType === this.FAMILY_GROUP
    },

    productPromotion() {
      return this.promotionType === this.SINGLE_PRODUCT
    },

    rangePromotion() {
      return this.promotionType === this.BY_RANGE
    },

    supportsRetailerChoice() {
      return this.familyPromotion || this.rangePromotion
    },

    requiresFixedFreeProduct() {
      return (
        !this.supportsRetailerChoice ||
        this.freeSelectionMode === this.FIXED_PRODUCT
      )
    },

    newPromotion() {
      return _.isEmpty(this.buyGetFreePromotion)
    },

    endDateDisplay() {
      return this.$options.filters.formatDatePicker(this.endDate)
    },

    startDateDisplay() {
      return this.$options.filters.formatDatePicker(this.startDate)
    },

    minAllowedEndDate() {
      return minAllowedPromotionEndDate(
        this.startDate,
        this.tenantCountryRegion
      )
    },

    minAllowedStartDate() {
      return minAllowedPromotionStartDate(this.tenantCountryRegion)
    },

    blockingBuyGetFreePromotions() {
      if (!Array.isArray(this.allBuyGetPromotions)) return []

      return this.allBuyGetPromotions.filter((promo) => {
        const endsToday =
          promo.endDate && moment(promo.endDate).isSame(moment(), 'day')
        const isBlockingStatus =
          promo.status === 'ACTIVE' || promo.status === 'UPCOMING'

        return (
          isBlockingStatus &&
          !endsToday &&
          promo.id !== this.buyGetFreePromotion?.id
        )
      })
    },

    buyGetFreeBlockedProductCodes() {
      const promotionProducts = new Set()

      this.blockingBuyGetFreePromotions.forEach((promo) => {
        if (promo.byRange) {
          ;(promo.rangeProducts || []).forEach((code) =>
            promotionProducts.add(code)
          )
          return
        }

        if (promo.familyGroupId) {
          const familyGroup = this.familyGroups.find(
            (group) => group.id === promo.familyGroupId
          )
          ;(familyGroup?.productCodes || []).forEach((code) =>
            promotionProducts.add(code)
          )
          return
        }

        if (promo.productCode) {
          promotionProducts.add(promo.productCode)
        }
      })

      return promotionProducts
    },

    buyGetFreeBlockedFamilyGroupIds() {
      return new Set(
        this.blockingBuyGetFreePromotions
          .map((promo) => promo.familyGroupId)
          .filter(Boolean)
      )
    },

    listFamilyGroups() {
      return this.familyGroups
        .filter((f) => f.productCodes.length)
        .map((f) => ({
          text: f.name,
          value: f.id,
          disabled: this.familyGroupUnavailableForBuyGetFree(f)
        }))
        .sort((a, b) => a.text.localeCompare(b.text))
    },

    listProducts() {
      return this.products
        .filter((p) => p.status === 'LIVE')
        .map((p) => ({
          text: `${p.supplierItemId} / ${p.tradeItemDescription}`,
          title: `${p.supplierItemId} / ${p.tradeItemDescription}`,
          value: p
        }))
        .sort((a, b) => (a.text < b.text ? -1 : 1))
    },

    filteredByProductList() {
      const promotionProducts = new Set()
      const familyGroupProducts = new Set()

      this.blockingBuyGetFreePromotions.forEach((promo) => {
        if (promo.byRange) {
          ;(promo.rangeProducts || []).forEach((code) =>
            promotionProducts.add(code)
          )
        } else if (promo.familyGroupId) {
          const familyGroup = this.familyGroups.find(
            (group) => group.id === promo.familyGroupId
          )
          if (familyGroup) {
            familyGroup.productCodes.forEach((code) => {
              promotionProducts.add(code)
              familyGroupProducts.add(code)
            })
          }
        } else if (promo.productCode) {
          promotionProducts.add(promo.productCode)
        }
      })

      return this.products
        .filter((p) => p.status === 'LIVE')
        .map((p) => ({
          text: `${familyGroupProducts.has(p.productCode) ? 'F - ' : ''}${
            p.supplierItemId
          } / ${p.tradeItemDescription}`,
          value: p,
          disabled: promotionProducts.has(p.productCode)
        }))
        .sort((a, b) => a.text.localeCompare(b.text))
    },

    visibleByProductList() {
      return buildVisibleProductOptions({
        options: this.filteredByProductList,
        searchTerm: this.productSearchInput,
        selectedValues: this.selectedProduct ? [this.selectedProduct] : []
      })
    },

    hasValidTier() {
      const isEdit = !this.newPromotion
      const cap = this.maxFreeUnitsCap

      if (this.targetType === this.NATIONAL) {
        return BuyGetFreeHelper.hasValidNationalTiers(
          this.nationalTiers,
          isEdit,
          cap,
          this.requiresFixedFreeProduct
        )
      }

      if (
        this.targetType === this.STATE ||
        this.targetType === this.BANNER_GROUP ||
        this.targetType === this.MULTI_STORE_OPERATOR ||
        this.targetType === this.RETAILER_STORE
      ) {
        return BuyGetFreeHelper.hasValidStateTiers(
          this.stateTiers,
          isEdit,
          cap,
          this.requiresFixedFreeProduct
        )
      }

      return false
    },
    hasUnsavedTierDraft() {
      if (this.targetType === this.NATIONAL) {
        return BuyGetFreeHelper.hasUnsavedTiers(
          this.nationalTiers,
          this.requiresFixedFreeProduct
        )
      }

      return this.stateTiers.some((state) =>
        BuyGetFreeHelper.hasUnsavedTiers(
          state.tiers || [],
          this.requiresFixedFreeProduct
        )
      )
    },

    validDates() {
      return this.startDate && this.endDate >= this.startDate
    },

    validPromotionSelection() {
      if (this.targetType === this.NATIONAL) {
        return this.nationalTiers.length > 0
      }
      if (this.targetType === this.STATE) {
        return this.stateTiers.length > 0
      }

      if (this.selectedRangeProducts.length) {
        return true
      }

      return !!this.selectedFamilyGroup || !!this.selectedProduct
    },

    validPromotion() {
      const isValidImage =
        this.promotionType !== this.BY_RANGE ||
        !!this.imageFile ||
        !!this.buyGetFreePromotion?.promotionImageUrl
      const isValidTier = this.newPromotion ? this.hasValidTier : true
      return (
        this.changesMade &&
        this.promotionName &&
        this.promotionName.length <= 60 &&
        this.startDate &&
        this.endDate &&
        isValidTier &&
        !this.hasMixedRangeProductTypes &&
        this.validDates &&
        this.validPromotionSelection &&
        this.validPromotionProductAvailability &&
        this.targetType &&
        isValidImage
      )
    },

    isNational() {
      return this.targetType === this.NATIONAL
    },

    isState() {
      return this.targetType === this.STATE
    },

    filteredRangeProducts() {
      const promotionProducts = new Set()
      const familyGroupProducts = new Set()

      this.blockingBuyGetFreePromotions.forEach((promo) => {
        if (promo.byRange) {
          ;(promo.rangeProducts || []).forEach((code) =>
            promotionProducts.add(code)
          )
        } else if (promo.familyGroupId) {
          const familyGroup = this.familyGroups.find(
            (group) => group.id === promo.familyGroupId
          )
          if (familyGroup) {
            familyGroup.productCodes.forEach((code) => {
              promotionProducts.add(code)
              familyGroupProducts.add(code)
            })
          }
        } else if (promo.productCode) {
          promotionProducts.add(promo.productCode)
        }
      })

      return this.products
        .filter((product) => product.status === 'LIVE')
        .map((product) => ({
          text: `${familyGroupProducts.has(product.productCode) ? 'F - ' : ''}${
            product.supplierItemId
          } / ${product.tradeItemDescription}`,
          title: `${familyGroupProducts.has(product.productCode) ? 'F - ' : ''}${
            product.supplierItemId
          } / ${product.tradeItemDescription}`,
          value: product.productCode,
          disabled: promotionProducts.has(product.productCode)
        }))
        .sort((a, b) => (a.text < b.text ? -1 : 1))
    },

    visibleRangeProducts() {
      return buildVisibleProductOptions({
        options: this.filteredRangeProducts,
        searchTerm: this.rangeProductSearchInput,
        selectedValues: this.selectedRangeProducts,
        getSelectedValue: this.normalizeProductCode
      })
    },

    validPromotionProductAvailability() {
      if (this.productPromotion) {
        return !this.productUnavailableForBuyGetFree(this.selectedProduct)
      }

      if (this.familyPromotion) {
        const familyGroup = this.familyGroups.find(
          (group) => group.id === this.selectedFamilyGroup
        )
        return !this.familyGroupUnavailableForBuyGetFree(familyGroup)
      }

      if (this.rangePromotion) {
        return !this.selectedRangeProductObjects.some((product) =>
          this.productUnavailableForBuyGetFree(product)
        )
      }

      return true
    },
    targetBannerGroups() {
      return this.bannerGroups
        .map((bg) => ({
          text: bg.displayName,
          value: bg.id
        }))
        .sort((a, b) => a.text.localeCompare(b.text))
    },

    targetMultiStoreOperators() {
      return this.multiStoreOperators
        .map((mso) => ({
          text: mso.displayName,
          value: mso.id
        }))
        .sort((a, b) => a.text.localeCompare(b.text))
    },

    targetStores() {
      return this.retailerStores
        .map((store) => ({
          text: store.displayName,
          value: store.id
        }))
        .sort((a, b) => a.text.localeCompare(b.text))
    },
    selectedRangeProductObjects() {
      return this.selectedRangeProducts
        .map((selected) =>
          this.products.find(
            (p) => p.productCode === this.normalizeProductCode(selected)
          )
        )
        .filter(Boolean)
    },

    selectedRangeProductCodes() {
      return this.selectedRangeProducts
        .map((selected) => this.normalizeProductCode(selected))
        .filter(Boolean)
    },

    freeProductCandidates() {
      if (this.rangePromotion) {
        return this.listProducts.map((option) => option.value)
      }

      return []
    },

    hasMixedRangeProductTypes() {
      if (!this.rangePromotion) return false
      return BuyGetFreeHelper.hasMixedRangeProductTypes(
        this.selectedRangeProductObjects
      )
    },

    multiTierActive() {
      const nat = (this.nationalTiers || []).length > 1
      const stateHasMulti = (this.stateTiers || []).some(
        (s) => (s.tiers || []).length > 1
      )
      return nat || stateHasMulti
    },

    availableStates() {
      return [
        ...new Set((this.pricingRegions || []).map((region) => region.state))
      ]
        .filter(Boolean)
        .sort()
    }
  },

  methods: {
    ...mapActions('notifications', ['addNotification']),

    normalizeProductCode(productOrCode) {
      if (typeof productOrCode === 'string') {
        return productOrCode
      }

      if (productOrCode?.productCode) {
        return productOrCode.productCode
      }

      if (typeof productOrCode?.value === 'string') {
        return productOrCode.value
      }

      return productOrCode?.value?.productCode || null
    },

    productUnavailableForBuyGetFree(productOrCode) {
      const productCode = this.normalizeProductCode(productOrCode)
      return (
        !!productCode && this.buyGetFreeBlockedProductCodes.has(productCode)
      )
    },

    familyGroupUnavailableForBuyGetFree(familyGroup) {
      if (!familyGroup) return false
      if (this.buyGetFreeBlockedFamilyGroupIds.has(familyGroup.id)) return true

      return (familyGroup.productCodes || []).some((code) =>
        this.buyGetFreeBlockedProductCodes.has(code)
      )
    },

    createBluePrint() {
      return {
        promotionType: this.promotionType,
        selectedFamilyGroup: this.selectedFamilyGroup,
        selectedProduct: this.selectedProduct,
        targetBannerGroupIds: this.targetBannerGroupIds,
        targetMultiStoreOperatorIds: this.targetMultiStoreOperatorIds,
        targetStoreIds: this.targetStoreIds,
        selectedRangeProducts: this.selectedRangeProducts,
        promotionName: this.promotionName,
        startDate: this.startDate,
        endDate: this.endDate,
        targetType: this.targetType,
        freeSelectionMode: this.freeSelectionMode,
        maxFreeUnitsCap: this.maxFreeUnitsCap,
        promotionImageUrl: this.imageFile
          ? URL.createObjectURL(this.imageFile)
          : this.buyGetFreePromotion?.promotionImageUrl
      }
    },

    handleFamilyGroupSelection() {
      if (!this.newPromotion) return
      if (!this.selectedFamilyGroup) {
        this.promotionName = ''
        return
      }

      const familyGroup = this.familyGroups.find(
        ({ id }) => id === +this.selectedFamilyGroup
      )

      if (this.familyGroupUnavailableForBuyGetFree(familyGroup)) {
        this.selectedFamilyGroup = null
        this.promotionName = ''
        return
      }

      this.promotionName = `${familyGroup.name}`
    },

    handleProductSelection() {
      if (!this.newPromotion) return
      if (!this.selectedProduct || !this.selectedProduct.tradeItemDescription) {
        return
      }

      if (this.productUnavailableForBuyGetFree(this.selectedProduct)) {
        this.selectedProduct = null
        this.promotionName = ''
        return
      }

      this.promotionName = `${this.selectedProduct.tradeItemDescription}`
      this.$nextTick(() => {})
    },

    handleRangeProductSelection() {
      this.selectedRangeProducts = this.selectedRangeProducts.filter(
        (selected) =>
          this.normalizeProductCode(selected) &&
          !this.productUnavailableForBuyGetFree(selected)
      )
    },

    copyBuyGetPromotion() {
      this.promotionName = this.buyGetFreePromotion.name
      this.startDate = this.buyGetFreePromotion.startDate
      this.endDate = this.buyGetFreePromotion.endDate
      const isTieredTargetType = [
        'STATE',
        'BANNER_GROUP',
        'MULTI_STORE_OPERATOR',
        'RETAILER_STORE'
      ].includes(this.buyGetFreePromotion.targetType)
      this.freeSelectionMode =
        this.buyGetFreePromotion.freeSelectionMode || this.FIXED_PRODUCT
      this.maxFreeUnitsCap = this.buyGetFreePromotion.maxFreeUnitsCap || null

      this.targetBannerGroupIds =
        this.buyGetFreePromotion.targetBannerGroups?.map(
          (b) => b.bannerGroupId
        ) || []
      this.targetMultiStoreOperatorIds =
        this.buyGetFreePromotion.targetMultiStoreOperators?.map(
          (m) => m.multiStoreOperatorId
        ) || []
      this.targetStoreIds =
        this.buyGetFreePromotion.targetStores?.map((s) => s.storeId) || []
      if (this.buyGetFreePromotion.targetType === 'NATIONAL') {
        this.nationalTiers = this.buyGetFreePromotion.tiers.map((tier) => ({
          buyQuantity: tier.buyQty,
          freeProduct:
            this.products.find(
              (product) =>
                product.productCode === this.buyGetFreePromotion.freeProductCode
            )?.productCode || tier.freeProductCode,
          freeQuantity: tier.freeQty
        }))
        this.targetType = this.NATIONAL
      } else if (isTieredTargetType) {
        const groupedStateTiers = {}
        this.buyGetFreePromotion.tiers.forEach((tier) => {
          tier.targetStates.forEach((state) => {
            if (!groupedStateTiers[state.state]) {
              groupedStateTiers[state.state] = []
            }
            groupedStateTiers[state.state].push({
              buyQuantity: tier.buyQty,
              freeProduct:
                this.products.find(
                  (product) =>
                    product.productCode ===
                    this.buyGetFreePromotion.freeProductCode
                )?.productCode || tier.freeProductCode,
              freeQuantity: tier.freeQty
            })
          })
        })

        this.stateTiers = Object.keys(groupedStateTiers).map((stateName) => ({
          code: this.toStateCode(stateName),
          name: stateName,
          tiers: groupedStateTiers[stateName]
        }))
        this.targetType = this.buyGetFreePromotion.targetType
      } else if (this.buyGetFreePromotion.targetType === 'BANNER_GROUP') {
        this.targetBannerGroupIds =
          this.buyGetFreePromotion.targetBannerGroups?.map(
            (bg) => bg.bannerGroupId
          ) || []
        this.targetType = this.BANNER_GROUP
      } else if (
        this.buyGetFreePromotion.targetType === 'MULTI_STORE_OPERATOR'
      ) {
        this.targetMultiStoreOperatorIds =
          this.buyGetFreePromotion.targetMultiStoreOperators?.map(
            (mso) => mso.multiStoreOperatorId
          ) || []
        this.targetType = this.MULTI_STORE_OPERATOR
      } else if (this.buyGetFreePromotion.targetType === 'RETAILER_STORE') {
        this.targetStoreIds =
          this.buyGetFreePromotion.targetStores?.map((s) => s.storeId) || []
        this.targetType = this.RETAILER_STORE
      }

      if (this.buyGetFreePromotion.familyGroupId) {
        this.promotionType = this.FAMILY_GROUP
        this.selectedFamilyGroup = this.buyGetFreePromotion.familyGroupId
        this.handleFamilyGroupSelection()
      } else if (this.buyGetFreePromotion.productCode) {
        this.promotionType = this.SINGLE_PRODUCT
        this.selectedProduct = this.products.find(
          (product) =>
            product.productCode === this.buyGetFreePromotion.productCode
        )
        this.handleProductSelection()
      } else if (this.buyGetFreePromotion.byRange) {
        this.promotionType = this.BY_RANGE
        this.selectedRangeProducts = (
          this.buyGetFreePromotion.rangeProducts || []
        )
          .map((productCode) =>
            this.filteredRangeProducts.find(
              (product) => product.value === productCode
            )
          )
          .filter(Boolean)
      }
    },

    confirmSaveBuyGetFreePromotion() {
      this.saveBuyGetFreePromotion()
      this.unsavedTiersDialog = false
    },

    handleSaveBuyGetFreePromotion() {
      if (this.saving) return
      this.saving = true
      this.saveBuyGetFreePromotion()
    },

    saveBuyGetFreePromotion() {
      this.saving = true
      const formData = new FormData()
      const validNationalTiers = this.nationalTiers.filter(
        (tier) =>
          !tier.isNew &&
          tier.buyQuantity &&
          (!this.requiresFixedFreeProduct || tier.freeProduct) &&
          tier.freeQuantity &&
          tier.buyQuantity > 0 &&
          tier.freeQuantity > 0
      )

      const isTieredTargetType =
        this.targetType === 'STATE' ||
        this.targetType === 'BANNER_GROUP' ||
        this.targetType === 'MULTI_STORE_OPERATOR' ||
        this.targetType === 'RETAILER_STORE'
      const filteredStateTiers = isTieredTargetType
        ? this.stateTiers
            .map((state) => ({
              ...state,
              tiers: state.tiers.filter(
                (tier) =>
                  !tier.isNew &&
                  tier.buyQuantity &&
                  (!this.requiresFixedFreeProduct || tier.freeProduct) &&
                  tier.freeQuantity &&
                  tier.buyQuantity > 0 &&
                  tier.freeQuantity > 0
              )
            }))
            .filter((state) => state.tiers.length > 0)
        : []
      const payload = {
        id: this.buyGetFreePromotion?.id,
        name: this.promotionName,
        productCode: this.selectedProduct?.productCode || null,
        freeSelectionMode: this.freeSelectionMode,
        freeProductCode: !this.requiresFixedFreeProduct
          ? null
          : this.targetType === 'NATIONAL'
            ? this.nationalTiers[0]?.freeProduct
            : this.targetType === 'STATE' ||
                this.targetType === 'BANNER_GROUP' ||
                this.targetType === 'MULTI_STORE_OPERATOR' ||
                this.targetType === 'RETAILER_STORE'
              ? filteredStateTiers[0]?.tiers[0]?.freeProduct
              : null,
        familyGroupId: this.selectedFamilyGroup || null,
        targetType: this.targetType,
        targetStates:
          this.targetType === 'NATIONAL'
            ? ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']
            : this.targetType === 'STATE' ||
                this.targetType === 'BANNER_GROUP' ||
                this.targetType === 'MULTI_STORE_OPERATOR' ||
                this.targetType === 'RETAILER_STORE'
              ? filteredStateTiers.map((state) => this.toStateCode(state))
              : null,
        startDate: this.startDate,
        endDate: this.endDate,
        targetBannerGroupIds:
          this.targetType === this.BANNER_GROUP
            ? this.targetBannerGroupIds
            : [],
        targetMultiStoreOperatorIds:
          this.targetType === this.MULTI_STORE_OPERATOR
            ? this.targetMultiStoreOperatorIds
            : [],
        targetStoreIds:
          this.targetType === this.RETAILER_STORE ? this.targetStoreIds : [],
        tiers:
          this.targetType === 'NATIONAL'
            ? validNationalTiers.map((tier) => ({
                buyQty: tier.buyQuantity,
                freeQty: tier.freeQuantity
              }))
            : this.targetType === 'STATE' ||
                this.targetType === 'BANNER_GROUP' ||
                this.targetType === 'MULTI_STORE_OPERATOR' ||
                this.targetType === 'RETAILER_STORE'
              ? filteredStateTiers.flatMap((state) =>
                  state.tiers.map((tier) => ({
                    buyQty: tier.buyQuantity,
                    freeQty: tier.freeQuantity,
                    state: this.toStateCode(state)
                  }))
                )
              : [],
        byRange: this.promotionType === this.BY_RANGE,
        rangeProducts:
          this.promotionType === this.BY_RANGE
            ? this.selectedRangeProductCodes
            : null,
        maxFreeUnitsCap: this.maxFreeUnitsCap || null
      }
      formData.append(
        'request',
        new Blob([JSON.stringify(payload)], { type: 'application/json' })
      )
      if (this.imageFile) {
        formData.append('file', this.imageFile)
      }
      this.newPromotion
        ? this.addBuyGetFreePromotion(formData)
        : this.updateBuyGetFreePromotion(formData)
    },

    addBuyGetFreePromotion(formData) {
      addBuyGetFreePromotion(this.selectedSupplierId, formData)
        .then(() => {
          this.addNotification({
            color: 'secondary',
            text: 'Buy Get Free has been created!'
          })
          this.$emit('save')
        })
        .catch((err) => {
          this.saving = false
          this.handleBackendError(err)
        })
        .finally(() => {
          this.saving = false
        })
    },

    updateBuyGetFreePromotion(formData) {
      updateBuyGetFreePromotion(
        this.selectedSupplierId,
        this.buyGetFreePromotion.id,
        formData
      )
        .then((response) => {
          this.addNotification({
            color: 'secondary',
            text: 'Buy Get Free has been Updated!'
          })
          if (response?.data?.promotionImageUrl) {
            this.buyGetFreePromotion.promotionImageUrl =
              response.data.promotionImageUrl
          }
          this.$emit('save')
        })
        .catch((err) => {
          console.error('Error in updating promotion:', err)
          this.addNotification({
            color: 'error',
            text:
              err.response?.data?.message || 'Failed to update the promotion.'
          })
        })
        .finally(() => {
          this.saving = false
        })
    },

    resetPromotionForm() {
      this.freeSelectionMode = this.FIXED_PRODUCT
      Object.keys(PROMOTION_FIELDS).forEach((key) => {
        if (key === 'targetType') {
          if (this.newPromotion) {
            this.targetType = this.NATIONAL
          }
        } else {
          this[key] = PROMOTION_FIELDS[key]
        }
      })
      this.nationalTiers = [
        {
          buyQuantity: '',
          freeProduct: '',
          freeQuantity: '',
          isNew: false,
          isAdded: false
        }
      ]
      this.stateTiers = [
        {
          name: 'ACT',
          tiers: [
            {
              buyQuantity: '',
              freeProduct: '',
              freeQuantity: '',
              isNew: false,
              isAdded: false
            }
          ]
        },
        {
          name: 'NSW',
          tiers: [
            {
              buyQuantity: '',
              freeProduct: '',
              freeQuantity: '',
              isNew: false,
              isAdded: false
            }
          ]
        },
        {
          name: 'QLD',
          tiers: [
            {
              buyQuantity: '',
              freeProduct: '',
              freeQuantity: '',
              isNew: false,
              isAdded: false
            }
          ]
        }
      ]
      this.targetBannerGroupIds = []
      this.targetMultiStoreOperatorIds = []
      this.targetStoreIds = []
      this.maxFreeUnitsCap = null
    },

    handleTargetTypeChange(value) {
      if (!value) {
        this.addNotification({
          color: 'error',
          text: 'Target type is required!'
        })
      }
    },

    updateNationalTiers(updatedTiers) {
      this.nationalTiers = updatedTiers
    },

    updateStateTiers(updatedTiers) {
      this.stateTiers = updatedTiers
    },

    toStateCode(state) {
      const value =
        typeof state === 'string' ? state : state?.code || state?.name
      return value?.split(' - ')[0] || value
    },

    triggerImageUpload() {
      this.$refs.imageUploader.click()
    },

    handleImageUpload(event) {
      const file = event.target.files[0]
      if (!file) return
      this.imageFile = file
    },

    removeImage() {
      this.imageFile = null
    },

    handleApplySavedRetailers(ids) {
      this.targetStoreIds = ids
      this.savedListApplied = true
    },

    resetRetailers() {
      this.targetStoreIds = []
      this.savedListApplied = false
    },

    handleTierCountsChange() {
      if (
        this.multiTierActive &&
        (this.maxFreeUnitsCap || this.maxFreeUnitsCap === 0)
      ) {
        this.maxFreeUnitsCap = null
        if (this.addNotification) {
          this.addNotification({
            color: 'info',
            text: 'Max Cap has been disabled because multiple tiers are present.'
          })
        }
      }
    },

    getFamilyGroupProductsById(familyGroupId) {
      if (!familyGroupId) return []

      const match = this.familyGroups.find((f) => f.id === familyGroupId)
      if (!match || !match.productCodes?.length) return []
      const matchedProduct = match.productCodes.map((code) => {
        const product = this.products.find((p) => p.productCode === code)
        return product ? product.tradeItemDescription : null
      })
      return matchedProduct.filter(Boolean)
    }
  },

  watch: {
    maxFreeUnitsCap(newVal) {
      const hasCap =
        newVal !== null &&
        newVal !== undefined &&
        newVal !== '' &&
        Number(newVal) > 0

      // ✅ When Max Cap is removed — re-enable multiple tiers
      if (!hasCap) {
        this.nationalTiers.forEach((t) => (t.isAdded = false))
        this.stateTiers.forEach((s) =>
          s.tiers.forEach((t) => (t.isAdded = false))
        )
        return
      }

      // ✅ When Max Cap added — restrict to one tier
      if (this.nationalTiers.length > 1) {
        this.nationalTiers = [
          { ...this.nationalTiers[0], isAdded: true, isNew: false }
        ]
      } else if (this.nationalTiers.length === 1) {
        this.nationalTiers[0].isAdded = true
        this.nationalTiers[0].isNew = false
      }

      this.stateTiers = (this.stateTiers || []).map((s) => {
        if ((s.tiers || []).length > 0) {
          const t0 = { ...s.tiers[0], isAdded: true, isNew: false }
          return { ...s, tiers: [t0] }
        }
        return {
          ...s,
          tiers: [
            {
              buyQuantity: '',
              freeProduct: '',
              freeQuantity: '',
              isAdded: false,
              isNew: false
            }
          ]
        }
      })
    },

    nationalTiers: {
      deep: true,
      handler() {
        this.handleTierCountsChange()
      }
    },
    stateTiers: {
      deep: true,
      handler() {
        this.handleTierCountsChange()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

#edit-buy-get-free-promotion {
  display: flex !important;
  flex-direction: column;
  overflow: hidden;
  box-shadow: none;
  background: $bg-secondary-color;
  .v-card__text {
    flex-grow: 1;
    overflow: auto;
  }
}
.v-autocomplete__content .v-subheader {
  background: var(--v-secondary-lighten1);
  font-weight: bold;
  font-style: italic;
}

.image-upload-container {
  margin-top: 12px;
}
.image-controls {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 8px;
}

.edit-btn,
.remove-btn {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  width: 32px;
  height: 32px;
}

.edit-btn v-icon,
.remove-btn v-icon {
  font-size: 18px;
}

.image-fit {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.image-preview-card {
  background-color: #f8f9fa;
  width: 100%;
  height: 170px;
  max-width: 350px;
  border-radius: 5px;
  border-width: 0px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.remove-image-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  z-index: 10;
}

.v-tooltip__content {
  background-color: #2e2e2e !important;
  color: #fff !important;
}

@media only screen and (min-width: 960px) {
  #edit-buy-get-free-promotion {
    th span {
      font-size: 14px;
    }
  }
}
</style>
